import { EVENT_KEYS } from 'presentation/events';
import { always } from 'core/utils';
import {
    createLoginStateFactory,
    createAddEntryStateFactory,
    createRemoveEntryStateFactory,
    createUpdateReportStateFactory,
    createUpdateEntryStateFactory,
    createSetEntriesStateFactory,
    createEntryAdsStateFactory,
    createResetTasksStateFactory,
    createTaskListPositionFactory,
    createTaskListsStateFactory,
    createAddEntryLayoutFactory,
    createEditEntryLayoutFactory,
    createEditEntryPaymentsLayoutFactory,
    createSearchLayoutFactory,
    createInsertEntryStateFactory,
    asisFactory,
    defaultToNull,
    defaultToEmptyArr,
    defaultToEmptyTasks,
    defaultToEmptyLayout,
    createLoaderStateFactory,
    createUpdateTasksStateFactory,
    createEntriesLayoutFactory
} from 'factories';

export const loginActionMap = {
    [EVENT_KEYS.LOGIN] : createLoginStateFactory,
    default : defaultToNull
};

export const taskActionMap = {
    [EVENT_KEYS.UPDATE_TASKS] : createUpdateTasksStateFactory,
    [EVENT_KEYS.RESET_TASKS] : createResetTasksStateFactory,
    default : defaultToEmptyTasks
};

export const statsActionMap = {
    [EVENT_KEYS.GET_STATS] : asisFactory,
    default : defaultToEmptyArr
};

export const adsActionMap = {
    [EVENT_KEYS.SET_ENTRY_ADS] : createEntryAdsStateFactory,
    default : defaultToEmptyArr
};

export const taskListActionMap = {
    [EVENT_KEYS.SET_TASK_LISTS] : createTaskListsStateFactory,
    default : defaultToEmptyArr
};

export const entriesActionMap = {
    [EVENT_KEYS.SET_ENTRIES] : createSetEntriesStateFactory,
    [EVENT_KEYS.ADD_ENTRY] : createAddEntryStateFactory,
    [EVENT_KEYS.INSERT_ENTRY] : createInsertEntryStateFactory,
    [EVENT_KEYS.UPDATE_ENTRY] : createUpdateEntryStateFactory,
    [EVENT_KEYS.UPDATE_ALL_ENTRIES] : asisFactory,
    [EVENT_KEYS.REMOVE_ENTRY] : createRemoveEntryStateFactory,
    default : defaultToEmptyArr
};

export const editEntryActionMap = {
    [EVENT_KEYS.BEGIN_EDIT_ENTRY] : asisFactory,
    [EVENT_KEYS.END_EDIT_ENTRY] : always(null),
    default : defaultToNull
};

export const reportsActionMap = {
    [EVENT_KEYS.UPDATE_REPORTS] : asisFactory,
    [EVENT_KEYS.UPDATE_CURRENT_REPORT] : createUpdateReportStateFactory,
    default : defaultToEmptyArr
};

export const upliftEntryActionMap = {
    [EVENT_KEYS.BEGIN_UPLIFT_ENTRY] : asisFactory,
    [EVENT_KEYS.END_UPLIFT_ENTRY] : always(null),
    default : defaultToNull
};

export const editEntryPaymentsActionMap = {
    [EVENT_KEYS.BEGIN_EDIT_ENTRY_PAYMENTS] : asisFactory,
    [EVENT_KEYS.END_EDIT_ENTRY_PAYMENTS] : always(null),
    default : defaultToNull
};

export const selectedListActionMap = {
    [EVENT_KEYS.UPDATE_SELECTED_TASK_LIST] : asisFactory,
    [EVENT_KEYS.UPDATE_LIST_LIMITS] : asisFactory,
    default : defaultToNull
};

export const layoutActionMap = {
    [EVENT_KEYS.LOAD_LISTS] : createLoaderStateFactory,
    [EVENT_KEYS.LOAD_STATS] : createLoaderStateFactory,
    [EVENT_KEYS.LOAD_ENTRIES] : createLoaderStateFactory,
    [EVENT_KEYS.LOAD_NEW_ENTRY] : createLoaderStateFactory,
    [EVENT_KEYS.LOAD_REPORTS] : createLoaderStateFactory,
    [EVENT_KEYS.RESET_TASK_LIST] : createTaskListPositionFactory,
    [EVENT_KEYS.SHOW_ADD_ENTRY] : createAddEntryLayoutFactory,
    [EVENT_KEYS.SHOW_EDIT_ENTRY] : createEditEntryLayoutFactory,
    [EVENT_KEYS.UPDATE_SEARCH_LAYOUT] : createSearchLayoutFactory,
    [EVENT_KEYS.SHOW_EDIT_ENTRY_PAYMENTS] : createEditEntryPaymentsLayoutFactory,
    [EVENT_KEYS.UPDATE_ENTRIES_LAYOUT] : createEntriesLayoutFactory,
    default : defaultToEmptyLayout
};
